<div class="pos-panel">
    <div class="pos-panel-header">
        <span class="soc-panel-header">{{'DIVISION.FACILITIES' | translate}}</span>
        <hr class="soc-panel-line" />
    </div>
    <div class="d-flex justify-content-between">
        <span class="soc-h4">{{'DIVISION.DIVISIONS' | translate}}</span>
    </div>
    <hr class="soc-panel-line"/>
    <div class="soc-content-panel-wrapper h-100">
        <div *ngIf="divisions && divisions.length == 0 && searchTerm == '' && !loading" class="pos-no-entities-wrapper h-100" >
            <div class="pos-no-entities-indicator h-100" style="width: 460px;">
                <span class="divisions-icon nav-icon "
                    style="width: 67px; height: 67px; background-color: var(--soc-cyan);"></span>
                <span class="soc-h2 text-center">{{'DIVISION.DIVISIONS' | translate}}</span>
                <span class="soc-p text-center" style="white-space: pre-line;">{{'DIVISION.CREATE_DIVISION_TEXT' |
                    translate}}</span>
                <button class="soc-basic-cyan-btn" (click)="newDivision()">{{'DIVISION.NEW_FIRST_DIVISION' |
                    translate}}</button>
            </div>
        </div>
        <div *ngIf="divisions && (divisions.length > 0 || searchTerm != '' || loading)" class="soc-wrapper-gap-24-column">
            <div class="pos-actions-wrapper">
                <div class="soc-search-wrapper">
                    <div class="p-inputgroup soc-search-field-wrapper">
                        <i class="pi pi-search soc-neutral-text-color"></i>
                        <input type="text" class="soc-search-input-field soc-input-text" [(ngModel)]="searchTerm" (ngModelChange)="search()" placeholder="{{'SEARCH' | translate}}">
                    </div>
                </div>
                <button class="soc-basic-cyan-btn" (click)="newDivision()"><span
                        class="material-icons-round">local_printshop</span>{{'DIVISION.NEW_DIVISION' | translate}}</button>
            </div>
            <hr class="soc-panel-line"/>
        </div>
        <div *ngIf="!divisions || loading" class="soc-loading-wrapper">
            <p-progressSpinner strokeWidth="4"></p-progressSpinner>
        </div> 
        <div *ngIf="divisions && divisions.length > 0 && !loading" style="display: flex;height: calc(100vh - 470px);overflow: auto;flex-direction: column;gap: 24px;">
            <div class="pos-panel-cards-wrapper">
                <ng-container *ngFor="let division of divisions">
                    <div class="soc-card ">
                        <span class="divisions-icon nav-icon "
                            style="width: 40px; height: 40px; background-color: var(--soc-cyan);"></span>
                        <div class="soc-card-info">
                            <div class="d-flex justify-content-between w-100">
                                <div class="soc-card-title">
                                    <span class="soc-h2">{{division.name}}</span>
                                </div>
                                <span class="material-icons neutral-90 "
                                    (click)="$event.stopPropagation(); actionMenu.toggle($event)">more_vert</span>
                                <p-overlayPanel #actionMenu [dismissable]="true" class="d-none">
                                    <div class="soc-action-menu-content">
                                        <div class="soc-action-item" (click)="editDivision(division)">
                                            {{'DIVISION.EDIT_DIVISION' | translate}}</div>
                                        <div class="soc-action-item" (click)="deleteDivision(division)">
                                            {{'DIVISION.DELETE_DIVISION' | translate}}</div>
                                    </div>
                                </p-overlayPanel>

                            </div>
                            <div class="d-flex justify-content-between w-100 gap-4">
                                <div class="soc-wrapper-gap-12-column w-50">
                                    <div class="soc-card-subtitle">
                                        <span class="soc-display-lbl w-100">{{'DIVISION.PRINTER' |translate}}</span>
                                    </div>
                                    <hr class="soc-split-line">
                                    <label _ngcontent-ley-c309="" class="soc-lbl-text-16 soc-neutral-50-text-color"
                                        style="height: 24px;">{{division.printerAddress}}</label>
                                </div>
                                <div class="soc-wrapper-gap-12-column w-50">
                                    <div class="soc-card-subtitle">
                                        <span class="soc-display-lbl w-100">{{'DIVISION.INVENTORY' |translate}}</span>
                                    </div>
                                    <hr class="soc-split-line">
                                    <label _ngcontent-ley-c309="" class="soc-lbl-text-16 soc-neutral-50-text-color"
                                        style="height: 24px;">{{division.inventory?.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<p-confirmDialog class="soc-confirmation-dialog">
</p-confirmDialog>